// path: src/pages/IPA/Negociacoes/pages/DetalhesDaNegociacao/visaoDaNegociacaoSalva.ts

/** O grão gravado de uma negociação salva, exigido em vez de assumido. */

export type VisaoGravada = 'STORE' | 'CLUSTER' | 'NETWORK';

const VISOES: VisaoGravada[] = ['STORE', 'CLUSTER', 'NETWORK'];

export const visaoDaNegociacaoSalva = (visaoDaResposta?: string | null): VisaoGravada => {
  if (visaoDaResposta && VISOES.includes(visaoDaResposta as VisaoGravada)) {
    return visaoDaResposta as VisaoGravada;
  }

  throw new Error(
    `A negociação salva não declarou um grão que esta tela conhece, e escolher um por omissão mandaria a ação com o recorte errado. Recebido: ${visaoDaResposta ?? 'nada'}`,
  );
};
